"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_BUTTON_CATEGORY_KEY = 'base';
exports.REDIRECT_BUTTON_COMPONENT_KEY = 'redirectButton';